(() => {
  if (customElements.get('product-media-viewer')) return;

  class ProductMediaViewer extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-viewer-stage]');
      if (!this.stage) return;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.querySelector('[data-viewer-controls]')?.removeAttribute('hidden');
      this.addEventListener('click', (event) => {
        const selection = event.target.closest('[data-viewer-select]');
        const play = event.target.closest('[data-viewer-play]');
        if (selection) this.select(selection.dataset.viewerSelect);
        if (play) this.activate(play.dataset.viewerPlay);
      }, options);
      document.addEventListener('product:variant-change', (event) => {
        const scope = this.dataset.productUiScope || this.closest('.product-layout, .featured-product-showcase, [data-search-product-drawer]');
        if (event.detail?.scope !== scope) return;
        const id = event.detail.variant?.featured_media_id;
        if (id) this.select(String(id));
      }, options);
      document.addEventListener('product-media:activate', (event) => {
        if (event.detail !== this) this.stop();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
      }, options);
      const slide = this.closest('[data-homepage-hero-slide]');
      if (slide) {
        this.slideObserver = new MutationObserver(() => {
          if (slide.hidden) this.stop();
        });
        this.slideObserver.observe(slide, { attributes: true, attributeFilter: ['hidden'] });
      }
    }

    disconnectedCallback() {
      this.stop();
      this.listeners?.abort();
      this.slideObserver?.disconnect();
    }

    select(id) {
      const template = this.querySelector(`template[data-viewer-preview="${id}"]`);
      if (!template) return;
      this.stop();
      this.dataset.mediaId = id;
      this.stage.replaceChildren(template.content.cloneNode(true));
      this.querySelectorAll('[data-viewer-select]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.viewerSelect === id));
      });
    }

    activate(id) {
      const template = this.querySelector(`template[data-viewer-native="${id}"]`);
      if (!template) return;
      document.dispatchEvent(new CustomEvent('product-media:activate', { detail: this }));
      this.active = true;
      this.stage.replaceChildren(template.content.cloneNode(true));
      const media = this.stage.querySelector('video, iframe, model-viewer');
      media?.focus();
      if (media?.tagName === 'MODEL-VIEWER' && window.Shopify?.loadFeatures) {
        if (!document.querySelector('[data-product-model-ui-styles]')) {
          const styles = document.createElement('link');
          styles.rel = 'stylesheet';
          styles.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
          styles.dataset.productModelUiStyles = '';
          document.head.append(styles);
        }
        window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {
          if (media.isConnected && window.Shopify.ModelViewerUI) {
            this.modelUI = new window.Shopify.ModelViewerUI(media);
          }
        } }]);
      }
    }

    stop() {
      if (!this.active || !this.stage) return;
      this.stage.querySelectorAll('video').forEach((video) => video.pause());
      this.modelUI?.destroy();
      this.modelUI = null;
      const template = this.querySelector(`template[data-viewer-preview="${this.dataset.mediaId}"]`);
      // Removing the iframe stops either supported external-video provider.
      this.stage.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      this.active = false;
    }
  }
  customElements.define('product-media-viewer', ProductMediaViewer);
})();
